import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { environment } from '@unico-people/shared/utils/environments';

export interface FeatureFlagModel {
  flag_key: string;
  entity_id: string;
  context: {
    organization_id: string;
  }
}

@Injectable({
  providedIn: 'root'
})
export class DataAccessFeatureFlagService {
  private url: string = environment.url_admission_api;

  constructor(private http: HttpClient) {}

  /**
   * @param {FeatureFlagModel} data for requisition in flip
   * @returns Boolean feature flag rule returns
   */
  hasFlag(data: FeatureFlagModel): Observable<any> {
    return this.http.post(`${this.url}/tools/flags/evaluate`, data).pipe(
      catchError((error) => of({ match: false }))
    );
  }
}
